<template>
  <div>
    <div class="root-login">
      <div class="login-box">
        <div class="forPic">
          <img
            ref="welcomeImg"
            class="welcomeImg"
            src="img/ai/viki-animations-new/Wellcome-screen.gif"
          />
        </div>

        <div class="login-box-body">
          <p class="login-box-msg">
            <vue-typer
              :class="timeDelay"
              :erase-delay="450"
              :erase-on-complete="false"
              :pre-erase-delay="300"
              :pre-type-delay="1300"
              :repeat="false"
              :shuffle="true"
              :text="[
                '\nWelcome To The finance section',
                '\nPlease enter your password'
              ]"
              :type-delay="70"
              caret-animation="blink"
              erase-style="select-all"
              initial-action="typing"
            ></vue-typer>
          </p>

          <form @submit.prevent="confirmPassword()">
            <div
              :class="{ 'has-error': err }"
              class="input-group mb-3 "
              style="display: flex"
            >
              <div class="input-group-prepend">
                <input
                  v-model="password"
                  class="form-control"
                  placeholder="Password"
                  type="password"
                />
              </div>
              <button
                :class="{ 'btn-danger': err }"
                class="btn btn-sm "
                style="max-height: 34px;"
                type="submit"
              >
                confirm
              </button>
            </div>
            <small v-if="err" class="form-text text-muted"
              >Password don't match</small
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
import apiClientCreator from "@/helpers/api/request";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ConfirmPassword",

  data() {
    return {
      password: "",
      err: false
    };
  },
  components: {
    "vue-typer": VueTyper
  },
  computed: {
    ...mapState("user", ["auth"])
  },
  mounted() {
    //this.$emit("enterPersonalTab");
  },
  methods: {
    async confirmPassword() {
      let apiClient = apiClientCreator("users/authenticate");
      let response = await apiClient.post("", {
        username_special: this.password,
        email: this.auth.user.email,
        password: this.password
      });

      if (response.data === 1) {
        this.err = false;
        this.$emit("enterPersonalTab");
      } else {
        this.err = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.root-login {
  width: 573px;
  min-height: 790px;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.forPic {
  width: 200px;
  height: 200px;
  box-sizing: border-box;
  margin-bottom: -150px;
  margin-top: -12px;
  background: white;
}

.welcomeImg {
  width: 200px;
  height: 200px;
  margin-left: -18px;
  margin-right: auto;
  padding-bottom: 5px;
  border-radius: 5px;
}

.login-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  max-width: 540px;
  min-width: 300px;
  height: 220px;
  background: white;
  padding: 20px;
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 230px;
  left: 0;
}

.login-box input {
  width: calc(100% - 40px);
  padding: 0.7rem;
  border: 0;
}

.login-box span {
  margin-left: 0;
}

.bttn {
  width: 100%;
  margin-top: 0.5rem;
  background: #efefef;
  color: black;
  border: 0;
  /*border-radius: inherit;*/
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  font-family: inherit;
  cursor: pointer;
}

.login-box-body {
  width: 321px;
}

.login-box-msg {
  min-height: 40px;
}

.form-control-feedback > img {
  width: 1em;
}
</style>
